<template>
  <scheduled />
</template>

<script>
import Scheduled from "./scheduled/Index.vue";

export default {
  name: "TripScheduled",
  components: { Scheduled },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
